import { Subject, takeUntil } from 'rxjs';

import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  inject,
} from '@angular/core';
import { FormControl } from '@angular/forms';

import { UiHelpersService } from '../../services';

@Component({
  selector: 'phoenix-unit-nanos-control',
  template: `
    <mat-form-field class="w-full">
      <mat-label>{{ label }}</mat-label>
      <input
        name="unitNanosControl"
        type="number"
        (ngModelChange)="onTransactionAmountChange()"
        matInput
        [formControl]="balance"
      />
    </mat-form-field>
  `,
  standalone: false,
})
export class UnitNanosControlComponent implements OnDestroy, OnChanges {
  @Input() unit = new FormControl('');
  @Input() nanos = new FormControl(0);
  @Input() label = 'Balance';

  uiHelpers = inject(UiHelpersService);

  destroy$ = new Subject<void>();
  balance = new FormControl(0);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['unit'] || changes['nanos']) {
      this.destroy$.next();

      this.unit.disabled ? this.balance.disable() : this.balance.enable();
      this.unit.statusChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(status => {
          if (status === 'DISABLED') {
            this.balance.disable();
          } else {
            this.balance.enable();
          }
        });
      this.setBalance();
      this.unit.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.setBalance();
      });

      this.nanos.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.setBalance();
      });
    }
  }

  setBalance() {
    const amount = this.uiHelpers.getAmount(
      Number(this.unit.value ?? '0'),
      this.nanos.value ?? 0
    );

    if (amount !== this.balance.value) {
      this.balance.setValue(amount);
    }
  }

  onTransactionAmountChange() {
    const data = this.uiHelpers.getUnitsNanos(this.balance.value ?? 0);
    data.units !== this.unit.value && this.unit.setValue(data.units);
    data.nanos !== this.nanos.value && this.nanos.setValue(data.nanos);
    this.unit.markAsDirty();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
